import ContentGrouping from './content';
import ContributorsGrouping from './contributors';
import CreationDateGrouping from './creation-date';
import CreatorGrouping from './creator';
import FactDateishGrouping from './fact-dateish';
import IssuesGrouping from './issues';
import SourcesGrouping from './sources';
import TagsGrouping from './tags';
import TitleGrouping from './title';

function Groupings(
	ContentGrouping,
	ContributorsGrouping,
	CreationDateGrouping,
	CreatorGrouping,
	FactDateishGrouping,
	IssuesGrouping,
	SourcesGrouping,
	TagsGrouping,
	TitleGrouping
) {
	return {
		'content': ContentGrouping,
		'contributors': ContributorsGrouping,
		'creationDate': CreationDateGrouping,
		'creator': CreatorGrouping,
		'factDateish': FactDateishGrouping,
		'legalIssues': IssuesGrouping,
		'sources': SourcesGrouping,
		'tags': TagsGrouping,
		'title': TitleGrouping,
	}
}
Groupings.$inject = [
	'ContentGrouping',
	'ContributorsGrouping',
	'CreationDateGrouping',
	'CreatorGrouping',
	'FactDateishGrouping',
	'IssuesGrouping',
	'SourcesGrouping',
	'TagsGrouping',
	'TitleGrouping'
];

export default angular.module('groupings.index', [
		ContentGrouping,
		ContributorsGrouping,
		CreationDateGrouping,
		CreatorGrouping,
		FactDateishGrouping,
		IssuesGrouping,
		SourcesGrouping,
		TagsGrouping,
		TitleGrouping
	])
	.factory('Groupings', Groupings)
	.name;



// WEBPACK FOOTER //
// ./project/groupings/index.js